import { Utils } from 'app/core/utils';
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are
 *      sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded
 *      before your main file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of
 * browsers that automatically update themselves.
 * This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/*******************************************************************************
 * BROWSER POLYFILLS
 */



/*******************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js';  // Included with Angular CLI.



/*******************************************************************************
 * APPLICATION IMPORTS
 */

/**
 * Date, currency, decimal and percent pipes.
 * Needed for: All but Chrome, Firefox, Edge, IE11 and Safari 10
 */
// import 'intl';  // Run `npm install --save intl`.


if (!document.elementsFromPoint) {
    document.elementsFromPoint = elementsFromPoint;
}

function elementsFromPoint(x, y) {
  let parents = [];
  let parent = void 0;
  do {
    if (parent !== document.elementFromPoint(x, y)) {
      parent = document.elementFromPoint(x, y);
      parents.push(parent);
      parent.style.pointerEvents = 'none';
    } else {
      parent = false;
    }
  } while (parent);
  parents.forEach(function (p) {
    return p.style.pointerEvents = 'all';
  });
  return parents;
}

import * as xmlSerializer from 'xmlserializer';

// Some serializer don't support custom namespaces completely. Such a serializer
// is used by old Apple devices.
const serializerSupportsCustomNamespace = () => {
  const defaultNamespace = 'http://www.w3.org/2000/svg';
  const otherNamespace = 'http://otherNamespace/';

  // I didn't found a better way to check it. If you find one, change it.
  const svg = document.createElementNS(defaultNamespace, 'svg');
  svg.setAttributeNS(otherNamespace, 'foobar:foo', 'bar');
  const childSvg = document.createElementNS(defaultNamespace, 'svg');
  svg.appendChild(childSvg);
  childSvg.setAttributeNS(otherNamespace, 'foobar:testelement', 'test');
  try {
    const svgString = new XMLSerializer().serializeToString(svg);
    return svgString.includes('foobar:testelement');
  }
  catch (e) {
    return false;
  }
};

const xmlSerializerSubstitutionIsRequired = () => {
  return !serializerSupportsCustomNamespace();
};

if (xmlSerializerSubstitutionIsRequired()) {
  (<any>window).XMLSerializer = () => xmlSerializer;
}

if (!(<any>document).fonts || !(<any>document).fonts.ready) {
  (<any>document).fonts = {
    // IPhone 5 (IOS 10.3.3) requires 750ms
    ready: Utils.sleep(750)
  };
}
